import { render } from "./ModeDarkSPA.vue?vue&type=template&id=1868d977"
import script from "./ModeDarkSPA.vue?vue&type=script&lang=js"
export * from "./ModeDarkSPA.vue?vue&type=script&lang=js"

import "./ModeDarkSPA.vue?vue&type=style&index=0&id=1868d977&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__